import * as React from "react";
import {
  Text,
  Image,
  StyleSheet,
  View,
  TouchableOpacity,
  Dimensions,
  Animated,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { useNavigation } from "@react-navigation/native";
import Swiper from "react-native-swiper/src";
import UnderLine from "../../components/AnimatedUnderLine";
import GenericButton from "../../components/GenericButton.js"
import GlobalStyles from "../../components/GlobalStyles";
import { checkLastLoginAndRoute } from "../../redux/actions/UserActions";
import Colors from "../../utilities/Color";

const FadeInView = (props) => {
  const fadeAnim = React.useRef(new Animated.Value(0)).current; // Initial value for opacity: 0

  React.useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      delay: 500,
      duration: 500,
      useNativeDriver: false
    }).start();
  }, [fadeAnim]);

  return (
    <Animated.View // Special animatable View
      style={{
        ...props.style,
        opacity: fadeAnim, // Bind opacity to animated value
      }}
    >
      {props.children}
    </Animated.View>
  );
};

export default function WelcomeScreen() {
  const navigation = useNavigation();
  const BGimage = require("../../assets/images/welcome/yellow_circle.png");
  const MenuLogo = require("../../assets/images/welcome/aura_white.png");
  const win = Dimensions.get("window");
  return (
    <View style={GlobalStyles.containerW}>
      <FadeInView>
        <View style={styles.backgroundContainerContainer}>
          <View style={styles.backgroundContainer}>
            <Image
              style={styles.backgroundImage}
              source={BGimage}
              resizeMode="cover"
            />
          </View>
        </View>
      </FadeInView>
      <ScrollView style={styles.scrollArea}>
        <FadeInView>
          <View style={styles.container}>
            <View
              style={[win.width > 765 ? styles.containerBW : styles.containerB]}
            >
              <View style={styles.containerA}>
                <Image
                  style={styles.tinyLogo}
                  source={MenuLogo}
                  resizeMode="contain"
                />
              </View>
              <Swiper
                style={styles.wrapper}
                showsButtons={false}
                horizontal={true}
                showsPagination={true}
                autoplay={true}
                autoplayTimeout={5}
                activeDotColor="#FFC72C"
              >
                <View style={styles.slide1}>
                  <Image
                    style={styles.typoicon}
                    source={require("../../assets/images/welcome/buy.png")}
                    resizeMode="contain"
                  />
                  <Text style={styles.textStyleHeader}>BUY</Text>
                  <Text style={styles.textStyleSubHeader}>
                    Earn cash on your everyday spending.
                  </Text>
                  <Text style={styles.textStyleDesc}>
                    You’ll earn real money, rather than points, from purchases
                    at hundreds of partners, including some of your favourite
                    brands. You can spend it or save it, or a bit of both. It’s
                    up to you.
                  </Text>
                </View>
                <View style={styles.slide2}>
                  <Image
                    style={styles.typoicon}
                    source={require("../../assets/images/welcome/invest.png")}
                    resizeMode="contain"
                  />
                  <Text style={styles.textStyleHeader}>INVEST</Text>
                  <Text style={styles.textStyleSubHeader}>
                    Invest and grow your well-earned cash.
                  </Text>
                  <Text style={styles.textStyleDesc}>
                    The money you earn builds over time, and you will have the
                    option to put in a managed investment fund in your name, so
                    it can grow your savings even more.
                  </Text>
                </View>
                <View style={styles.slide3}>
                  <Image
                    style={styles.typoicon}
                    source={require("../../assets/images/welcome/donate.png")}
                    resizeMode="contain"
                  />
                  <Text style={styles.textStyleHeader}>DONATE</Text>
                  <Text style={styles.textStyleSubHeader}>
                    Support your favourite charity or club.
                  </Text>
                  <Text style={styles.textStyleDesc}>
                    We’ll donate 10% on top of your cashback to the community
                    group or charity of your choice. Even your kids’ local
                    sports club can sign up for our support.
                  </Text>
                </View>
              </Swiper>
            </View>
            <View
              style={[win.width > 765 ? styles.containerW : styles.containerC]}
            >
              {/*  this commneted section can be removed by 28/10/2023*/}
              {/* <TouchableOpacity
                style={styles.SubmitButtonStyle}
                activeOpacity={0.5}
                onPress={() => navigation.navigate("SignUpModeChoice")}
              >
                <Text style={styles.textStyleButton}>
                  NEW MEMBER? REGISTER NOW
                </Text>
              </TouchableOpacity> */}
              <View style={{ marginTop: 10 }}>
                <GenericButton
                  buttonText=' NEW MEMBER? REGISTER NOW'
                  onPress={() => navigation.navigate("SignUpModeChoice")}
                />
              </View>
              <View style={{ marginTop: 30 }}>
                <GenericButton
                    buttonColor={null}
                    borderWidth={1}
                    borderColor={Colors.DARKGRAY}
                    buttonText='LOG IN'
                    onPress={() => checkLastLoginAndRoute(navigation) } //navigation.navigate("LoginModeChoice")
                  />
                </View>
              <Text style={styles.versionText}>1.6.1c</Text>
            </View>
          </View>
        </FadeInView>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  backgroundContainer: {
    flex: 1,
    position: "absolute",
    top: -350,
    width: 600,
    height: 600,
    alignSelf: "center",
  },
  backgroundContainerContainer: {
    alignItems: "center",
  },
  backgroundImage: {
    width: 600,
    height: 600,
  },
  // this commneted section can be removed by 28/10/2023
  // SubmitButtonStyle: {
  //   marginTop: 10,
  //   paddingTop: 15,
  //   paddingBottom: 15,
  //   backgroundColor: "#4CC9EE",
  //   borderRadius: 30,
  // },
  // this commneted section can be removed by 28/10/2023
  // textStyleButton: {
  //   color: "#FFF",
  //   textAlign: "center",
  //   fontFamily: "montserrat-bold",
  //   fontSize: 14,
  // },
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  containerA: {
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: 35,
  },
  containerB: {
    marginTop: 30,
    height: 610,
  },
  containerBW: {
    marginTop: 30,
    height: 610,
  },
  containerC: {
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 30,
  },
  containerW: {
    alignSelf: "center",
    width: 353,
    paddingBottom: 30,
  },
  tinyLogo: {
    height: 60,
    width: 120,
  },
  typoicon: {
    marginTop: 55,
    height: 120,
    width: 120,
    alignSelf: "center",
  },
  logo: {
    width: 66,
    height: 58,
    resizeMode: "contain",
  },
  LinkBar: {
    width: 70,
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  TextStyleLink: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    paddingTop: 30,
  },
  textStyleHeader: {
    color: "#2F7999",
    textAlign: "center",
    fontFamily: "montserrat-light",
    fontSize: 46,
    paddingTop: 30,
  },
  textStyleSubHeader: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 16,
    paddingTop: 30,
  },
  textStyleDesc: {
    color: "#6A6E71",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    lineHeight: 22,
    maxWidth: 300,
    alignSelf: "center",
    paddingTop: 30,
  },
  textStyleSubDesc: {
    color: "#6A6E71",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    maxWidth: 300,
    alignSelf: "center",
    paddingTop: 10,
  },
  versionText: {
    paddingTop: 20,
    paddingBottom: 20,
    color: "#eeeeee",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "center",
  },
});
